/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PhoneIcon from '../../../assets/phone-icon.svg';
import HouseIcon from '../../../assets/house-icon.svg';
import { ZipcodeInput } from './Inputs/ZipcodeInput';
import { AddressStateInput } from './Inputs/AddressStateInput';
import { AddressCountryInput } from './Inputs/AddressCountryInput';
import { AddressCityInput } from './Inputs/AddressCityInput';
import { AddressStreetInput } from './Inputs/AddressStreetInput';
import { AddressNumberInput } from './Inputs/AddressNumberInput';
import { AddressComplementInput } from './Inputs/AddressComplementInput';
import { EmailInput } from './Inputs/EmailInput';
import { ConfirmEmailInput } from './Inputs/EmailConfirmInput';
import { PhoneInput } from './Inputs/PhoneInput';
import { EmailRecaptcha } from './Inputs/EmailRecaptcha';

export function AccessFormComplete() {
  const { t } = useTranslation('user_data_confirmation');
  const { t: t2 } = useTranslation('redo-register-v2');
  return (
    <div className="access-form-container" data-testid="first-access-form-complete">
      <div className="access-form-header">
        <img src={PhoneIcon} alt="phone icon" />
        <h3 data-testid="first-access-contact-label">{t2('contact_label')}</h3>
      </div>

      <div className="access-form-content">
        <div>
          <EmailInput />

          <span className="email-warning" data-testid="first-access-email-warning">
            {t('avoid_corporate_emails')}
          </span>
        </div>
        <ConfirmEmailInput />
        <PhoneInput />
        <EmailRecaptcha />
      </div>

      <div className="form-divider" />

      <div className="access-form-header">
        <img src={HouseIcon} alt="phone icon" data-testid="first-access-address-icon" />
        <h3 data-testid="first-access-address-label">{t2('address_label')}</h3>
      </div>

      <div className="access-form-content last">
        <AddressCountryInput />
        <ZipcodeInput />
        <AddressStreetInput />
        <AddressNumberInput />
        <AddressComplementInput />
        <AddressCityInput />
        <AddressStateInput />
      </div>
    </div>
  );
}
